import React from "react";
import { Toast } from "@sscs/ui";
import { Dialog } from "Components";
import { apiErrorToast } from "Utils";
import { useUnshareReportMutation } from "../../../services/sharedReports.api";

type StopSharingReportDialogProps = {
  purl: string;
  onClose: () => void;
  isOpen: boolean;
  token: string;
  linkName: string;
};

const StopSharingReportDialog = ({
  purl,
  onClose,
  isOpen,
  token,
  linkName,
}: StopSharingReportDialogProps): React.JSX.Element => {
  const [unshareReport] = useUnshareReportMutation();

  const stopSharing = async () => {
    try {
      await unshareReport({
        token_key: token,
      }).unwrap();

      Toast.show({
        title: "Link has been deactivated",
        type: "success",
      });
    } catch (error) {
      apiErrorToast(error, "Could not deactivate link");
      return;
    }

    onClose();
  };

  return (
    <Dialog
      title={
        <>
          Stop sharing report <em>{linkName}</em>
        </>
      }
      subtitle={<code>{purl}</code>}
      confirmText="Stop sharing"
      isOpen={isOpen}
      onCancel={onClose}
      onClose={onClose}
      onConfirm={stopSharing}
      cancelButtonColor="secondary"
      confirmButtonColor="primary"
    >
      <p>
        <strong>Are you sure you want to stop sharing this report? </strong>
      </p>
      <p>
        The existing report link will be invalidated immediately. Anyone with
        the link will no longer be able to view the report.
      </p>
      <p>
        <strong>The report can be shared again</strong> at any time by
        generating a new link.
      </p>
    </Dialog>
  );
};

export default StopSharingReportDialog;
